
import * as Constants from './Constants';

const initialState = {
  qualificationData: {},
  addDeviceData: {},
  error:null,
  isLoading: false,
  multiLineQualificationData: {},
};

function qualificationCheckDetails(state = initialState, action) {
  switch (action.type) {
    case Constants.START_LOADING:
      return{...state, isLoading:true};
    case Constants.STOP_LOADING:
      return{...state, isLoading:false}  
    case Constants.GET_WESTWORLD_SUCCESS:
      return { ...state, qualificationData: action.response?.data, multiLineQualificationData:action.response, isLoading: false };
    case Constants.ERR_OCCURED:
      return { ...state, qualificationData: action, isLoading: false };
    case Constants.ADD_DEVICE_SUCCESS:
        return { ...state, addDeviceData: action.response };
    case Constants.ADD_DEVICE_ERROR:
          return { ...state, addDeviceData: action };
    default:
      return state;
  }
}


export default qualificationCheckDetails;